import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Container } from "react-grid-system";
import "views/contractView/styles/newElementFormStyles.css";
import { RoutePath, FormMode, DocumentType, DsLayout, ResponseStatus, ResponseCode } from "shared/constants";
import { StepperType } from "views/contractView/components/newElementFormStepper";
import Stepper from "views/contractView/components/newElementFormStepper";
import TransportFormDataInput from "views/contractView/components/transportFormDataInput";
import { ITransport, IDocument } from "dataModels/contract";
import { InputAttach, Button } from "@ds/ds-snam/react";
import { DSInput, DSSelectList } from "@ds/ds-snam/dist/index";
import DSFileInput from "components/DSFileInput";
import { FileStatusEnum, IFileUpload } from "dataModels/fileInput";
import { DatePicker } from "@ds/ds-snam/react";
import moment from "moment";
import TransportFormReview from "./transportFormReview";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { useDispatch, useSelector } from "react-redux";
import { showNotification, hideNotification } from "state/reducer/notificationSlice";
import { useNavigate, useParams, useLoaderData } from "react-router-dom";
import { DATE_FORMAT } from "shared/constants";
import { postTransport, putTransport } from "net/contracts";
import { DSFile } from "@ds/ds-snam/dist/index";
import { useTranslation } from "react-i18next";
import SystemError from "components/SystemError";
import { RootState } from "state/appStore";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";



const TransportForm: React.FC = (): JSX.Element => {
    //Transporter id - When access to retrieve and edit customer existing information, otherwise undefined
    const { id } = useParams();
    //Loaded transporter data when in edit mode
    const transporterData: ITransport | undefined = useLoaderData() as ITransport;
    //eslint-disable-next-line
    const [formMode, setFormMode] = useState<number>(id ? FormMode.EDIT : FormMode.NEW);
    const getDefaultFormData = () => {
        const defaultDoc: IDocument = {
            type: '',
            name: '',
            size: 0,
            content: '',
            expire: null
        }
        const defaultDocTruckInspection: IDocument = {
            type: 'truckInspection',
            name: 'null',
            size: 1,
            content: 'null',
            expire: null
        }
        
        const defaultFormData: ITransport = {
            id:'',
            businessName: '', //nome azienda trasportarrice
            businessSecondName: '', //ragione sociale
            businessAddress: '', //indirizzo azienda trasportatrice
            businessStreetNumber: '', //civico
            businessPostalCode: '', //CAP
            businessCity: '', //Città azienda
            businessProvince: '', //provincia azienda
            businessState: '', //stato azienda
            vat: '', //partita iva
            firstName: '', //nome persona di contatto
            secondName: '',
            email: '',
            countryCode: '', //prefisso cellulare
            phone: '',
            documents: [defaultDoc,defaultDocTruckInspection,defaultDoc],
            delegations:[],
            status:2
        }
        return defaultFormData;
    }

    const { t } = useTranslation(['contract', 'app']);
    const [formStep, setFormStep] = useState<number>(0);
    const [formData, setFormData] = useState<ITransport>(formMode === FormMode.NEW ? getDefaultFormData() : transporterData);

    const [formError, setFormError] = useState<boolean>(false);
    const [phoneError, setPhoneError] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const onTextInputChange = (inputEvent: Event) => {
        //console.log(inputEvent)
        const fieldName = (inputEvent as CustomEvent).detail.input.name;
        const inputValue = (inputEvent as CustomEvent).detail.input.value;
        let currentData: ITransport = formData;
        //console.log(currentData);
        (currentData[fieldName as keyof ITransport] as string) = inputValue;
        setFormData(currentData);

        // Validazione separata per il campo email
        if (fieldName === "email") {
            validateEmailField();
        }

        if (fieldName === "phone") {
            setPhoneError(inputValue !== "" && !/^\d+$/.test(inputValue));
        }
    }
    const onStateInputChange = (inputEvent: Event) => {
        let selection = (inputEvent as CustomEvent).detail.option.value
        let currentFormData = {...formData};
        currentFormData.countryCode=selection;
        setFormData(currentFormData);

    }
    const onSelectInputChange = (event: Event,fieldName:String) => {
        const selection: ISelectLabel = (event as CustomEvent).detail.option;
        /*let currentFormData = { ...formData };
        (currentFormData[fieldName as keyof ICustomer] as string) = selection?.value!;
        setFormData(currentFormData);*/

        setFormData(prevFormData => ({
            ...prevFormData,
            [fieldName as keyof ITransport]: selection?.value || "" // Aggiorna il campo specificato con il nuovo valore
        }));
    }
    const onDateInputChange = (inputEvent: Event, fieldName: string) => {
        const date: string = (inputEvent as CustomEvent).detail.dateSelection;
        //let currentData: ITransport = formData;
        formData.documents[2].expire = moment.utc(date, DATE_FORMAT).unix();
        //console.log(date, moment(date, DATE_FORMAT).unix());
        //(currentData[fieldName as keyof ITransport] as number) = moment(date, DATE_FORMAT).unix();
    }
    const prevStep = () => {
        const nextStep = formStep - 1;
        setFormStep(nextStep);
    }
    const nextStep = () => {
        const nextStep = formStep + 1;
        setFormStep(nextStep);
    }

const validateEmailField = (): void => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const value = formData.email as string;
    const emailElem: DSInput | null = document.querySelector("[input-id='email']");

    if (emailElem) {
        const isInvalid = value === "" || !emailRegex.test(value);
        emailElem.inputStatus = isInvalid ? "error" : "default";  // Imposta solo lo stato per il campo email
    }
};

const validatePhoneField = (): boolean => {
    const value = formData.phone as string;
    const phoneElem: DSInput | null = document.querySelector("[input-id='phone']");
    const isInvalid = value !== "" && !/^\d+$/.test(value);

    setPhoneError(isInvalid);

    if (phoneElem) {
        phoneElem.inputStatus = isInvalid ? "error" : "default";
    }

    return isInvalid;
};
/*const validateStep = (): number => {
    let errors: number = 0;
    
    // Validazione per la prima step
    if (formStep === 0) {
        Object.keys(formData).forEach((key: string) => {
            // Saltare il campo email, che è gestito separatamente
            if (key !== 'email') {
                const elem: DSInput | null = document.querySelector("[input-id='" + key + "']");
                if (elem) {
                    const content = formData[key as keyof ITransport]!;
                    const koCheck: boolean = content === "" || Number(content) <= 0;
                    elem.inputStatus = koCheck ? 'error' : 'default';
                    if (koCheck)
                        errors++;
                }
            }
        });

        validateEmailField(); // Validazione email

        // Validazione per i campi Select (provincia, nazione, stato)
        const provinceField: DSSelectList | null = document.querySelector("[id='id-select-province']");
        const nationField: DSSelectList | null = document.querySelector("[id='id-select-nation']");
        const stateField: DSSelectList | null = document.querySelector("[id='id-select-stateField_1']");

        if (provinceField) {
            const isProvinceEmpty = formData.businessProvince === "";
            provinceField.selectStatus = isProvinceEmpty ? "error" : "default";
            if (isProvinceEmpty) errors++;
        }
        if (nationField) {
            const isNationEmpty = formData.businessState === "";
            nationField.selectStatus = isNationEmpty ? "error" : "default";
            if (isNationEmpty) errors++;
        }
        if (stateField) {
            const isStateEmpty = formData.countryCode === "";
            stateField.selectStatus = isStateEmpty ? "error" : "default";
            if (isStateEmpty) errors++;
        }
    }

    // ... altre logiche di validazione per altre step
    
    return errors;
};   */


const validateStep = (): number => {
        let errors: number = 0;
        if (formStep === 0) {
            //console.log(formStep)
            Object.keys(formData).forEach((key: string) => {
                const elem: DSInput | null = document.querySelector("[input-id='" + key + "']");
                if (elem) {
                    const content = formData[key as keyof ITransport]!;
                    const koCheck: boolean = content === "" || Number(content) <= 0;
                    elem.inputStatus = koCheck ? 'error' : 'default';
                    if (koCheck)
                        errors++;
                }
            });

                if (validatePhoneField()) {
                    errors++;
                }

                // Controllo per i campi Select (provincia e nazione)
                const provinceField: DSSelectList | null = document.querySelector("[id='id-select-province']");
                const nationField: DSSelectList | null = document.querySelector("[id='id-select-nation']");
                const stateField: DSSelectList | null = document.querySelector("[id='id-select-stateField_1']");

                if (provinceField) {
                    const isProvinceEmpty = formData.businessProvince === "";
                    provinceField.selectStatus = isProvinceEmpty ? "error" : "default";
                    if (isProvinceEmpty) errors++;
                }
                        
                if (nationField) {
                    const isNationEmpty = formData.businessState === "";
                    nationField.selectStatus = isNationEmpty ? "error" : "default";
                    if (isNationEmpty) errors++;
                } 
                
                        
                if (stateField) {
                    const isStateEmpty = formData.countryCode === "";
                    stateField.selectStatus = isStateEmpty ? "error" : "default";
                    if (isStateEmpty) errors++;
                } 
                
                
        } else if (formStep === 1) {
            for (let i = 0; i < 3; i++) {
                if(i!==1){ //Controllo aggiunto per saltare "Ownership agreement doc"
                const elem: DSFile | null = document.querySelector("[input-id='doc" + i + "']");
                //console.log(elem)
                let koCheck = false;
                if (formData.documents[i].name === '') {
                    koCheck = true;
                }
                if (koCheck)
                    errors++;
                if (elem)
                    if (elem.inputStatus === 'uploaded') {
                        //elem.inputStatus = elem.inputStatus;
                    } else {
                        if (koCheck) {
                            //console.log('entro in ',i, ' error')
                            elem.inputStatus = 'error'
                        } else {
                            //console.log('entro in ',i, ' default')
                            elem.inputStatus = 'default'
                        }
                    }
                }

            }
        }
        return errors;

    }

    useEffect(() => {
        return () => {
            dispatch(requestPristine());
        }
    }, [dispatch]);

    const saveFormData = useCallback(() => {
        const translationField: string = formMode === FormMode.NEW ? "new" : "edit";
        let popUpAction: INotificationAction;
        const request = formMode === FormMode.NEW ? postTransport : putTransport;
        dispatch(requestPending());
        request(formData).then((response) => {
            const popUpTitle:string = response.data.status===ResponseStatus.ERROR ? 'Error':(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT? '422': t(`transporter.transporterForm.successToast.${translationField}.title`) );
            const popUpDescription:string = response.data.status===ResponseStatus.ERROR||response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?response.data.message:t(`transporter.transporterForm.successToast.${translationField}.subTitle`);
            const popUpStatus:NotificationsStatusType = response.data.status===ResponseStatus.ERROR?"error":(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
                            
            popUpAction = {
                show: true,
                title: popUpTitle,//`Trasportatore inserito correttamente e approvato`,
                description: popUpDescription,//"Il profilo del trasportatore è stato inserito e approvato correttamente in piattaforma.",
                status: popUpStatus,
                onClose: (event: Event) => {
                    dispatch(hideNotification());
                }
            };
            dispatch(showNotification(popUpAction));
            if(formMode===FormMode.NEW){
                navigate(RoutePath.CONTRACTS_TRANSPORTATORS_INFO);
            }else{ //edit
                navigate(RoutePath.CONTRACTS_TRANSPORTATORS_INFO+"/"+id);
            }
            
        }).catch((error) => {
            console.log(error);
            setFormError(true);//error step
        }).finally(() => {
            dispatch(requestPristine());
        })
    }, [formData, dispatch, navigate, formMode, t]);

    return (

        <>
                {formMode===FormMode.NEW &&
                    <>
                        <p className="pageHeader">
                            {/*formStep===2?"Riepilogo trasportatore":"Inserisci trasportatore"*/}
                            {formStep===2?t('transporter.transporterForm.pageHeaders.new.1'):t('transporter.transporterForm.pageHeaders.new.0')}
                        </p>
                    </>
                }
                {formMode===FormMode.EDIT &&
                    <>
                        <p className="pageHeader">
                            {/*formStep===2?"Riepilogo trasportatore":"Modifica trasportatore"*/}
                            {formStep===2?t('transporter.transporterForm.pageHeaders.edit.1'):t('transporter.transporterForm.pageHeaders.edit.0')}
                        </p>
                    </>
                }
                {formStep >= 0 && formMode === FormMode.NEW &&
                    <Row>
                        <Col >
                            <Stepper
                                stepperType={StepperType.NEW_TRANSPORT}
                                currentStep={formStep+1}
                                finalStep={3} />
                        </Col>
                    </Row>
                }
            {formStep!==2 && <div className="listTableContainerGrey">
                
                {formError ? 
                    <SystemError link={RoutePath.CONTRACTS_TRANSPORTATORS_INFO} />
                : 
                    <>
                        {formStep === 0 &&
                            <>
                                <Row>
                                    <Col>
                                        <p className="formSubTitle">
                                            {/*Inserisci le informazioni dell'azienda trasportatrice*/}
                                            {t('transporter.transporterForm.title.0')}
                                        </p>
                                    </Col>
                                </Row>

                                <TransportFormDataInput
                                    formData={formData}
                                    phoneError={phoneError}
                                    onTextInputChange={onTextInputChange}
                                    //onDateInputChange={onDateInputChange}
                                    onStateInputChange={onStateInputChange}
                                    onSelectInputChange={onSelectInputChange}
                                />
                            </>
                        }

                        {formStep === 1 &&
                            <>
                                <Row>
                                    <Col>
                                        <div className="formSubTitle">
                                            {/*Inserisci la documentazione relativa all'azienda trasportatrice*/}
                                            {t('transporter.transporterForm.title.1')}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="fileInputWrapper">
                                            <DSFileInput
                                                title={t('transporter.documentEdit.fileInputTitle.securityTemplate')+"*"}//"Security Protocol Template*"
                                                //inputLabel={formData.documents.length ? "Caricamento file completato. Trascina o carica un'altro file per sostituirlo" : "Trascina il file per caricarlo"}
                                                inputLabel={formData.documents.length ? t('dsComponents.fileInput.defaultStatus.title', {ns:'app'}) : t('contract.contractForm.sections.fileInput.unloadedFile')}
                                                id="doc0"
                                                accept="application/pdf, image/jpg, image/jpeg"
                                                maxSize={10000000}
                                                defaultStatus={formData.documents[0].name !== '' ? FileStatusEnum.UPLOADED : FileStatusEnum.DEFAULT}
                                                onFileUpload={(fileUpload: IFileUpload, id: string) => {
                                                    //console.log("on file upload", fileUpload, id);
                                                    let currentFormData = { ...formData };
                                                    let base64String = btoa(fileUpload.content);
                                                    const documentObj: IDocument = {
                                                        type: DocumentType.SECURITY_TEMPLATE,//"securityTemplate",
                                                        name: fileUpload.name,
                                                        size: fileUpload.size,
                                                        content: base64String,
                                                        expire: null
                                                    }
                                                    currentFormData.documents[0] = documentObj;
                                                    setFormData(currentFormData);
                                                    //console.log(formData)
                                                }}
                                            />
                                        </div>
                                        {formData.documents[0].name !== '' ?
                                            <div className="uploadedFileWrapper">
                                                <InputAttach
                                                    attachName={formData.documents[0].name}
                                                    firstButtonDisabled={false}
                                                    secondButtonDisabled={false}
                                                    inputLabel={t('contract.contractForm.sections.fileInput.attachTitle')}//"File caricato"
                                                />
                                            </div>
                                            :
                                            <></>
                                        }
                                    </Col>
                                </Row>
                                {/*<Row>
                                    <Col>
                                        <div className="fileInputWrapper">
                                            <DSFileInput
                                                title={t('transporter.documentEdit.fileInputTitle.truckInspection')}//"Accordo ispezione truck di proprietà*"
                                                //inputLabel={formData.documents.length ? "Caricamento file completato. Trascina o carica un'altro file per sostituirlo" : "Trascina il file per caricarlo"}
                                                inputLabel={formData.documents.length ? t('dsComponents.fileInput.defaultStatus.title', {ns:'app'}) : t('contract.contractForm.sections.fileInput.unloadedFile')}
                                                id="doc1"
                                                accept="application/pdf, image/jpg, image/jpeg"
                                                maxSize={10000000}
                                                defaultStatus={formData.documents[1].name !== '' ? FileStatusEnum.UPLOADED : FileStatusEnum.DEFAULT}
                                                onFileUpload={(fileUpload: IFileUpload, id: string) => {
                                                    //console.log("on file upload", fileUpload, id);
                                                    let currentFormData = { ...formData };
                                                    const documentObj: IDocument = {
                                                        type: DocumentType.TRUCK_INSPECTION,//"truckInspection",
                                                        name: fileUpload.name,
                                                        size: fileUpload.size,
                                                        content: fileUpload.content,
                                                        expire: null
                                                    }
                                                    currentFormData.documents[1] = documentObj;
                                                    setFormData(currentFormData);
                                                    //console.log(formData)
                                                }}
                                            />
                                        </div>
                                        {formData.documents[1].name !== '' ?
                                            <div className="uploadedFileWrapper">
                                                <InputAttach
                                                    attachName={formData.documents[1].name}
                                                    inputLabel={t('contract.contractForm.sections.fileInput.attachTitle')}//"File caricato"
                                                />
                                            </div>
                                            :
                                            <></>
                                        }
                                    </Col>
                                </Row>*/}
                                <>
                                    <Row>
                                        <Col>
                                            <div className="fileInputWrapper">
                                                <DSFileInput
                                                    title={t('transporter.documentEdit.fileInputTitle.adrDeclaration')+"*"}//"Nomina consulente ADR*"
                                                    //inputLabel={formData.documents.length ? "Caricamento file completato. Trascina o carica un'altro file per sostituirlo" : "Trascina il file per caricarlo"}
                                                    inputLabel={formData.documents.length ? t('dsComponents.fileInput.defaultStatus.title', {ns:'app'}) : t('contract.contractForm.sections.fileInput.unloadedFile')}
                                                    id="doc2"
                                                    accept="application/pdf, image/jpg, image/jpeg"
                                                    maxSize={10000000}
                                                    defaultStatus={formData.documents[2].name !== '' ? FileStatusEnum.UPLOADED : FileStatusEnum.DEFAULT}
                                                    onFileUpload={(fileUpload: IFileUpload, id: string) => {
                                                        //console.log("on file upload", fileUpload, id);
                                                        let currentFormData = { ...formData };
                                                        let base64String = btoa(fileUpload.content);
                                                        const documentObj: IDocument = {
                                                            type: DocumentType.ADR_DECLARATION,//"adrDeclaration",
                                                            name: fileUpload.name,
                                                            size: fileUpload.size,
                                                            content: base64String,
                                                            expire: null
                                                        }
                                                        currentFormData.documents[2] = documentObj;
                                                        setFormData(currentFormData);
                                                        formData.documents[2].expire = moment(new Date(), DATE_FORMAT).unix();
                                                        //console.log(formData)
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {formData.documents[2].name !== '' &&
                                                <div className="uploadedFileWrapper" style={{paddingLeft:'16px'}}>
                                                    <InputAttach
                                                        attachName={formData.documents[2].name}
                                                        inputLabel={t('contract.contractForm.sections.fileInput.attachTitle')}//"File caricato"
                                                    />
                                                </div>
                                        }
                                        {formData.documents[2].name !== '' &&
                                            <Col xs={12} md={3}>
                                            <div className="expirationInputWrapper" style={{width:'196px'}}>
                                                <DatePicker
                                                    id="scadenzaDocAdr"
                                                    datePickerTitle={t('transporter.transporterForm.sections.fileInput.datePickerTitle')+"*"}//"Scadenza*"
                                                    isRangePicker={false}
                                                    datePickerVariant="full-date"
                                                    datePickerPlaceholder=""
                                                    startingYear={new Date().getFullYear()}
                                                    endingYear={2099}
                                                    defaultDate={new Date()}
                                                    disabledDates={{ lastDisabledDate: new Date(Date.now() - 86400000) }} 
                                                    isDisabled={false}
                                                    datePickerStatus="default"
                                                    confirmButtonLabel="Conferma"
                                                    hasCloseButton={false}
                                                    zIndex={999}
                                                    isReadonly={false}
                                                    isPanelTop={true}
                                                    onDateSelection={(event: Event) => {
                                                        onDateInputChange(event, 'startDate')
                                                    }}
                                                ></DatePicker>
                                            </div>
                                            </Col>
                                        }
                                    </Row>
                                </>
                            </>
                        }
                        
                    </>
                    
                }
            </div>
            }
            {formStep === 2 &&
                            <TransportFormReview
                                formData={formData}
                                formMode={formMode}
                            />}
            {/** Buttons */}
            {!formError && <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.8rem" }}>
                {formStep > 0 && <Button
                    style={{ marginRight: "0.8rem" }}
                    id="backButton"
                    buttonType="button"
                    buttonUIVariant="secondary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.back', { ns: 'app' })}//"Indietro"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={()=>{
                        formMode === FormMode.NEW ? prevStep(): setFormStep(formStep-2)}
                    }
                />}
                {formStep < 2 && <Button
                    id="nextButton"
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.next', { ns: 'app' })}//"Continua"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={() => {
                        let errors: number = validateStep();
                        if (errors === 0)
                            //nextStep();
                            formMode === FormMode.NEW ? nextStep() : setFormStep(formStep + 2);
                    }}
                />}
                {formStep === 2 && <Button
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.confirm', { ns: 'app' })}//"Conferma"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={(event: Event) => {
                        //console.log(formData)
                        saveFormData();
                    }}
                />}
            </div>}
        </>
    )
}
export default TransportForm;